<div class="funnel-form-wrapper m-0">
  <div class="funnel-form-section funnel-form d-flex flex-column mt-4 gap-3">
    <div class="title-section">
      <h1 class="funnel-title">Choose Sport</h1>
    </div>

    <div class="verticals-container container bg-transparent">
      <div *ngFor="let vertical of sportsGiftList" class="vertical-item primary-color-text-hover" (click)="selectVertical(vertical)">
        <a class="d-flex flex-column align-items-center" [ngClass]="{ 'selected': selectedVertical === vertical, 'coming-soon': vertical.comingSoon && !directNavigation }">
          <div class="image-container">
            <img [src]="vertical.image" [alt]="vertical.vertical" class="vertical-thumbnail">
          </div>
          <h4 class="vertical-title apply-text-hover heading-4 m-0 mt-1">{{ vertical.title }}</h4>
          <label *ngIf="vertical.comingSoon && !directNavigation" class="coming-soon subhead text-500 m-0">Coming Soon</label>
        </a>
      </div>
    </div>

    <div *ngIf="(!directNavigation)" class="form-button">
      <button
        class="btn btn-primary btn-lg w-100"
        data-test="choose-sport-submit-button"
        [disabled]="!canSubmit"
        (click)="onSubmit()"
      >
        Next
      </button>
  </div>
</div>
